import { observer } from 'mobx-react-lite'
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker';
import DateUtils from '@gap/utils/date-utils';

interface CommonDatePickerProps
   extends Omit<DatePickerProps, 'onChange' | 'value' | 'format'> {
   onChange?: (value: any) => any
   value: Date | null
   label?: string
   helperText?: string
   error?: boolean
   clearable?: boolean
   fullWidth?: boolean
   withTime?: boolean
}

// Date + time format (customize as needed)
const dateTimeFormat = `${DateUtils.DATE_FORMAT} hh:mm aa`

export default observer(function CommonDatePicker(props: CommonDatePickerProps) {
   const { onChange, value, error, helperText, clearable, fullWidth, withTime, ...all } = props

   // Configure slot props with MUI v7's slot API
   const slotProps: DatePickerProps['slotProps'] = {
      ...props.slotProps,
      textField: {
         ...props.slotProps?.textField,
         fullWidth,
         error: error || false,
         helperText: helperText || '',
      },
   }

   if (clearable) {
      slotProps.field = { ...slotProps.field, clearable: true }
   }

   return (
      <DatePicker
         {...all}
         format={withTime ? dateTimeFormat : DateUtils.DATE_FORMAT}
         slotProps={slotProps}
         onChange={onChange}
         value={value}
      />
   )
})
